<main class="payment">
  <div class="payment__container">
    @if (phase() === 'creating') {
      <!-- Skeleton mientras se prepara el intent. Nunca pantalla en blanco. -->
      <div
        class="payment__skeleton"
        role="status"
        aria-live="polite"
        aria-label="Preparando el pago"
      >
        <span class="payment__skeleton-line payment__skeleton-line--title"></span>
        <span class="payment__skeleton-block"></span>
        <span class="payment__skeleton-line"></span>
        <span class="payment__skeleton-line payment__skeleton-line--short"></span>
      </div>
    } @else if (phase() === 'failed') {
      <section class="payment__panel payment__panel--error" aria-labelledby="payment-error-title">
        <!-- Mascota de error: convierte el fallo en un momento de marca (regla de mascota:
             decorativa, sin NgOptimizedImage, width/height intrínsecos para evitar CLS). -->
        <img
          class="payment__panel-mascot"
          src="/images/logo/charging_error.png"
          alt=""
          aria-hidden="true"
          loading="lazy"
          width="640"
          height="626"
        />
        <h1
          id="payment-error-title"
          class="payment__title"
          tabindex="-1"
          data-phase-heading
        >
          {{ cardCopy.errorTitle }}
        </h1>
        <p class="payment__error" role="alert">{{ errorMsg() }}</p>
        <!-- Tranquilidad ante abandono: el carrito sigue intacto. -->
        <p class="payment__reassurance">
          @if (canRetry()) {
            {{ cardCopy.reassureRetry }}
          } @else {
            {{ cardCopy.reassureBack }}
          }
        </p>
        <div class="payment__actions">
          @if (canRetry()) {
            <app-button variant="primary" size="lg" (click)="retry()">Reintentar</app-button>
          }
          <button type="button" class="payment__link" (click)="backToCheckout()">
            Volver al carrito
          </button>
        </div>
      </section>
    } @else if (phase() === 'pending') {
      <section class="payment__panel" aria-labelledby="payment-pending-title">
        <h1
          id="payment-pending-title"
          class="payment__title"
          tabindex="-1"
          data-phase-heading
        >
          Tu pago está en proceso
        </h1>
        <p class="payment__subtitle">
          Estamos confirmando tu pago. En cuanto se acredite, tu pedido quedará registrado. Puedes
          comprobar el estado ahora o volver más tarde.
        </p>
        @if (errorMsg(); as msg) {
          <p class="payment__status" role="status" aria-live="polite">{{ msg }}</p>
        }
        <div class="payment__actions">
          <app-button
            variant="primary"
            size="lg"
            [disabled]="checking()"
            [loading]="checking()"
            (click)="checkSession()"
          >
            Comprobar estado
          </app-button>
          <button type="button" class="payment__link" (click)="backToCheckout()">
            Volver al carrito
          </button>
        </div>
      </section>
    } @else {
      <!-- ready / confirming -->
      <div class="payment__layout">
        <!-- Acompañamiento de marca: solo en la fase de pago activa, junto al formulario.
             En desktop queda a la izquierda; en mobile, arriba (orden natural del DOM). -->
        <aside class="payment__aside">
          <img
            class="payment__aside-mascot"
            src="/images/logo/charging.png"
            alt=""
            aria-hidden="true"
            loading="lazy"
            width="478"
            height="640"
          />
          <p class="payment__aside-tagline">
            La forma más perrona y segura de pagar en Perrón Store
          </p>
        </aside>

        <div class="payment__main">
          <header class="payment__header">
            <h1 class="payment__title" tabindex="-1" data-phase-heading>Pagar con tarjeta</h1>
            <p class="payment__amount">
              Total a pagar:
              <span class="payment__amount-value">{{ amountColones() | crc }}</span>
            </p>
            <!-- Countdown del HOLD de stock (solo si el backend abrió reserva): el gate ya protege; el
                 timer avisa de la ventana. Al expirar en 'ready' hace teardown (onReservationExpired). -->
            @if (reservationExpiresAt()) {
              <p class="payment__reservation" role="status" aria-live="polite">
                <app-countdown
                  [expiresAt]="reservationExpiresAt()"
                  [label]="reservationTimerLabel"
                  (expired)="onReservationExpired()"
                />
              </p>
            }
          </header>

          <section class="payment__panel" aria-labelledby="payment-card-title">
            <h2 id="payment-card-title" class="payment__panel-title">Pago con tarjeta</h2>

            <!-- Mount-point del SDK de ONVO. El widget pinta en el nodo interno [data-payment-mount]
                 (dedicado, fuera del control de Angular) para poder limpiarlo al reintentar sin tocar
                 la vista. El placeholder es hermano, gestionado por Angular. -->
            <div class="payment__card-mount" aria-live="polite">
              @if (!cardReady()) {
                <p class="payment__card-placeholder">
                  Cargando el formulario de pago seguro…
                </p>
              }
              <div #paymentMount data-payment-mount></div>
            </div>

            @if (phase() === 'confirming') {
              <p class="payment__status" role="status" aria-live="polite">Procesando tu pago…</p>
            }

            <div class="payment__actions">
              <app-button
                variant="primary"
                size="lg"
                [disabled]="!cardReady() || submitting()"
                [loading]="submitting()"
                (click)="onPayClick()"
              >
                Pagar {{ amountColones() | crc }}
              </app-button>
              <button type="button" class="payment__link" (click)="backToCheckout()">
                Volver al carrito
              </button>
            </div>
          </section>
        </div>
      </div>
    }
  </div>
</main>
